export const GET_SHIFT_TYPES = 'GET_SHIFT_TYPES';
